import gql from 'graphql-tag';

export default gql`
  mutation requestOrderCancellation($id: ID!) {
    order: requestOrderCancellation(id: $id) {
      id
    }
  }
`;
